import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import { logout } from "../../apiCalls/auth";
export default function VerificationEmailSentPage({email}) {
  const handleClick = () => {
    logout()
  };

  return (
    <Grid
      container
      sx={{
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <Grid
        item
        sx={{
          width: "365px",
          height: "151px",
          backgroundColor: "#FFFFFF",
          borderRadius: "4px",
          padding: "26px 30px 12px 30px"
        }}>
        <Grid container direction="column" sx={{ width: "100%", height: "100%", justifyContent: "space-between", alignItems: "center" }}>
          <Grid
            item
            sx={{
              width: "100%",
            }}>
            <Typography
              sx={{
                fontFamily: "Lato",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "normal", 
                color: "var(--Blacks-500, #100C08)",
              }}>
               We’ve sent a verification link to {email}. Check your inbox to complete your registration. If the email is incorrect, please update it and try again. 
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              width: "100%",
              height: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
              <Button onClick={handleClick} sx={{
                  width: "100%",
                  height: "100%",
                  padding: "5px 20px",
                  borderRadius: "6px",
                  backgroundColor: "#AC5CCC",
                  color: "#FFFFFF",
                  "&:hover": { backgroundColor: "#963ABB", color: "#FFFFFF" },
                }}
              >
              <Typography 
                sx={{
                  color: 'var(--Neutrals-100, #FFF)',
                  fontFamily: "Lato",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 700,
                  lineHeight: "normal", 
                  textTransform: "none",
                }}>
                  Logout
                </Typography>
              </Button>
              </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
